import React from 'react';
import './EclipseLoading.css';

const LoadingBar = ({classNames}) => {
    return (
        <div className="loadingio-spinner-eclipse-1wg002afh04">
            <div className="ldio-4l751vr6hhl">
                <div className={`${classNames}`}></div>
            </div>
        </div>
    );
}

export default LoadingBar;